import { useUISize } from 'app/utils/web-helpers';
import type { ComponentProps } from 'react';
import { OnboardingLayout as OnboardingLayoutSmall } from './layout.small';
import { OnboardingLayout as OnboardingLayoutLarge } from './layout.large';

export function OnboardingLayout(props: ComponentProps<typeof OnboardingLayoutSmall>) {
  const { isSmallUI } = useUISize();
  if (isSmallUI) {
    return <OnboardingLayoutSmall {...props} />;
  }
  return <OnboardingLayoutLarge {...props} />;
}
